import React, { useEffect, useState } from "react";
import styled from "styled-components";
import api from "../services/api";
import { toast } from "react-toastify";

/* OVERLAY */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

/* BOX */
const Box = styled.div`
  background: white;
  padding: 30px;
  border-radius: 18px;
  width: 420px;
  max-width: 95%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  animation: fade .25s ease;

  @keyframes fade{
    from{opacity:0; transform:scale(.95);}
    to{opacity:1; transform:scale(1);}
  }
`;

/* TITLE */
const Title = styled.h2`
  margin-bottom: 20px;
  color:#1e293b;
`;

/* INPUT */
const Input = styled.input`
  width:100%;
  padding:12px 14px;
  border-radius:10px;
  border:1px solid #e2e8f0;
  margin-bottom:20px;
  font-size:14px;

  &:focus{
    outline:none;
    border-color:#3b82f6;
  }
`;

/* BUTTONS */
const Buttons = styled.div`
  display:flex;
  justify-content:flex-end;
  gap:10px;
`;

/* BUTTON */
const Button = styled.button`
  padding:10px 18px;
  border-radius:10px;
  border:none;
  cursor:pointer;
  font-weight:600;
  font-size:13px;
  background:${p=>p.primary ? "#2563eb" : "#e2e8f0"};
  color:${p=>p.primary ? "white" : "#334155"};
  transition:.2s;

  &:hover{
    transform:scale(1.05);
  }
`;

/* COMPONENT */
export default function CaixaModal({ onClose, onSuccess }) {

  const [saldo, setSaldo] = useState("");       // para abertura
  const [saldoFinal, setSaldoFinal] = useState(""); // para fechamento
  const [loading,setLoading] = useState(false);
  const [caixaAberto,setCaixaAberto] = useState(false);

  useEffect(()=>{
    checkStatus();
  },[]);

  // Verifica se o caixa está aberto
  const checkStatus = async ()=>{
    try{
      const res = await api.get("/caixa/status");
      setCaixaAberto(res.data.aberto);
    }catch{
      setCaixaAberto(false);
    }
  };

  // ABRIR CAIXA
  const abrirCaixa = async () => {
    if(!saldo || Number(saldo) < 0){
      return toast.warning("Informe um saldo inicial válido");
    }

    try{
      setLoading(true);
      await api.post("/caixa/abrir",{
        saldo_inicial: saldo
      });
      toast.success("Caixa aberto com sucesso");
      onSuccess();
    }catch(err){
      toast.error(err.response?.data?.erro || "Erro ao abrir caixa");
    }finally{
      setLoading(false);
    }
  };

  // FECHAR CAIXA
  const fecharCaixa = async () => {
    if(!saldoFinal){
      return toast.warning("Informe o saldo final");
    }

    try{
      setLoading(true);
      // envia apenas saldoFinal para backend, diferença calculada no servidor
      await api.post("/caixa/fechar",{
        saldo_final: saldoFinal
      });
      toast.success("Caixa fechado com sucesso");
      onSuccess();
    }catch(err){
      toast.error("Erro ao fechar caixa");
    }finally{
      setLoading(false);
    }
  };

  return (
    <Overlay>
      <Box>
        <Title>{caixaAberto ? "Fechar Caixa" : "Abrir Caixa"}</Title>

        {caixaAberto ? (
          <>
            <Input
              type="number"
              placeholder="Saldo contado (manual)"
              value={saldoFinal}
              onChange={e=>setSaldoFinal(e.target.value)}
            />

            <Buttons>
              <Button onClick={onClose}>Cancelar</Button>
              <Button primary onClick={fecharCaixa}>
                {loading ? "Fechando..." : "Fechar Caixa"}
              </Button>
            </Buttons>
          </>
        ) : (
          <>
            <Input
              type="number"
              placeholder="Saldo inicial"
              value={saldo}
              onChange={e=>setSaldo(e.target.value)}
            />

            <Buttons>
              <Button onClick={onClose}>Cancelar</Button>
              <Button primary onClick={abrirCaixa}>
                {loading ? "Abrindo..." : "Abrir Caixa"}
              </Button>
            </Buttons>
          </>
        )}
      </Box>
    </Overlay>
  );
}